<template>
    <div class="main">
        <Navbar href="/" class="row">
            <template #back>vers Accueil</template>
            <template #title>Gestion des utilisateurs</template>
        </Navbar>

        <section class="row">
            <div class="field">
                <div class="searchbar">
                    <i class="material-icons">search</i><span>Rechercher</span><input type="text" v-model="searchInput" placeholder="Conseiller">
                </div>
            </div>
        
            <table>
                <thead>
                    <tr>
                        <th>
                            Nom
                        </th>
                        <th>Prénom</th>
                        <th>
                            Statue
                        </th>
                        <th>Rôles</th>
                    </tr>
                    <tr>
                        <th>
                            <label><input type="radio" v-model="order_by.last_name" value=""><i class="material-icons">filter_list_off</i></label>
                            <label><input type="radio" v-model="order_by.last_name" value="-last_name"><i class="material-icons">arrow_upward</i></label>
                            <label><input type="radio" v-model="order_by.last_name" value="last_name"><i class="material-icons">arrow_downward</i></label>
                        </th>
                        <th></th>
                        <th>
                            <label><input type="radio" v-model="order_by.is_active" value=""><i class="material-icons">filter_list_off</i></label>
                            <label><input type="radio" v-model="order_by.is_active" value="-is_active"><i class="material-icons">arrow_upward</i></label>
                            <label><input type="radio" v-model="order_by.is_active" value="is_active"><i class="material-icons">arrow_downward</i></label>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users_list">
                        <td class="col-w-40">{{ user.last_name }}</td>
                        <td class="col-w-40">{{ user.first_name }}</td>
                        <td class="col-w-20">
                            <SwitchButton 
                                v-model:checked="user.is_active"
                                :label_right="user.is_active  ? 'actif' : 'archivé'" 
                                :disabled="user.is_staff || userStore.current_user.id == user.id"
                                @change="toggleUser(user)"
                            >
                            </SwitchButton>
                        </td>
                        <td><button class="primary-button-outlined" @click="handleUserRoles(user)"><i class="material-icons">settings</i>&nbsp;Gérer</button></td>
                    </tr>
                </tbody>
            </table>
        </section>

        <aside class="mt-2 last-row">
            <div class="text-center">
                <span class="label">Nombre de conseillers par page&nbsp;:&nbsp;</span>
                <select v-model="page_size" @change="changePageSize($event.target.value)">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </select>
            </div>
            <div class="pagination">
                <button class="primary-button" :disabled="!prev_page_existes" @click="prevPage">Précédent</button>
                <span class="label">
                    Page&nbsp;:&nbsp;
                    <select v-model="page" @change="goToPage">
                        <option v-for="page in total_pages" :key="page" :value="page">{{ page }}</option>
                    </select>
                    /&nbsp;{{ total_pages }}
                </span>
                <button class="primary-button" :disabled="!next_page_existes" @click="nextPage">Suivant</button>
            </div>
        </aside>
    </div>

    <Modal v-model="toggleModal">
        <UserInfo :user="selectedUser" @closeMe="toggleModal = false"/>
    </Modal>
</template>


<script setup>
import apiClient from '@/api'
import Navbar    from '@/components/Navbar.vue';
import { onMounted, ref, watch, computed, reactive } from 'vue';
import { useUserStore } from '@/stores/userstore'
import SwitchButton from '@/components/SwitchButton.vue';
import Modal from '@/components/Modal.vue';
import UserInfo from '@/components/UserInfo.vue';

const userStore = useUserStore()

const users_list   = ref([])
const search       = ref('')
const searchInput  = ref('')
let timeout        = null
const toggleModal  = ref(false)
const selectedUser = ref({})

const order_by = reactive({
    is_active: '',
    last_name: 'last_name'
})

// used to send an array of orders, because the server handles the array and not an object
const order_by_array = computed(() =>
    Object.values(order_by).filter(value => value)
)

// pagination
const page              = ref(1)
const page_size         = ref(10)
const total_count       = ref(0)
const next_page_existes = ref(false)
const prev_page_existes = ref(false)

const fetchUsers = async () => {
    try {
        if (userStore.isLoggedIn && userStore.current_user_groups.includes('ADMIN_PANEL')) {
            const params = {
                search: JSON.stringify(search.value),
                order_by: JSON.stringify(order_by_array.value),
                page: page.value,
                page_size: page_size.value
            }

            const response = await apiClient.get('get_users/', { params })
            const data     = response.data

            if(data.results.users !== undefined) {
                users_list.value = data.results.users
            } else {
                users_list.value = []
            }

            // handles next and previous page buttons
            if(data.count !== undefined) {
                total_count.value = data.count
                next_page_existes.value = !!data.next
                prev_page_existes.value = !!data.previous
            } else {
                total_count.value = users.value.length
                next_page_existes.value = false
                prev_page_existes.value = false
            }
        }

    } catch (error) {
        // error
    }
}

const toggleUser = async (user) => {
    try {
        const formData = new FormData()
        formData.append('user_id', user.id)
        formData.append('is_active', !user.is_active)

        const response = await apiClient.post('toggle_user/', formData)

        console.log('Status : ', response.status)
        console.log('Message : ', response.data.message)

    } catch (error) {
        if (error.response) {
            console.log('Status : ', error.response.status)
            console.log('Message : ', error.response.data.message)
        } else if (error.request) {
            console.log('No response received : ', error.request)
        } else {
            console.log('Error : ', error.message)
        }
    }
}

const handleUserRoles = (user) => {
    // (toggleModal = !toggleModal) & (selectedUser = user.id)
    toggleModal.value = !toggleModal.value
    selectedUser.value = {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name
    }
}

onMounted(async () => {
    fetchUsers()
})

const total_pages = computed(() => Math.max(1, Math.ceil(total_count.value / page_size.value)))

const goToPage = (p) => {
    const num = parseInt(p, 10)
    if (!isNaN(num) && num >= 1 && num <= total_pages.value) page.value = num
}

const nextPage = () => {
    if (next_page_existes.value && page.value < total_pages.value) page.value++
}

const prevPage = () => {
    if(prev_page_existes.value && page.value > 1) page.value--
}

const changePageSize = (size) => {
    page_size.value = Number(size) || 10
    page.value = 1
}

watch ([page, page_size, () => order_by_array.value.join(','), search], () => {
    fetchUsers()
})

// input debounce
watch(searchInput, (newSearch, oldSearch, onCleanup) => {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
        search.value = searchInput.value;
        page.value = 1 // reset page    
    }, 800);

    onCleanup(() => {
        clearTimeout(timeout)
    });
})

</script>
<style scoped lang="scss">
.main {
    background-color: #fff;
    max-width: 100%;
    margin: 2rem auto;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.text-center {
    text-align: center;
}

.pagination {
    display: flex;
    gap: 2rem;
    justify-content: center;
    align-items: center;

    margin-top: 1rem;

    button:disabled {
        opacity: .5;

        cursor: no-drop;
    }
}

label:has(input[type='radio']) > input {
    display: none;
}


label:has(input[type='radio']) {
    cursor: pointer;
}

label:has(input[type='radio']:checked) {
    color: orange;
}

.label {
    color: $dark-blue;
    font-weight: bold;
    margin-bottom: 0.2rem;
}

table {
    width: 100%;

    .col-w-40 {
        width: 40%;
    }

    .col-w-20 {
        width: 20%;
    }

    tbody {
        tr:hover {
            background-color: rgba($muted-blue, .25);
        }
    }
}

label {
    display: inline;
    gap: 0;
}

.searchbar {
    display: flex;
    padding: 1rem;
    align-items: center;
    gap: 1rem;
    width: fit-content;
    border-radius: 15px;
    justify-content: start;
    margin: auto;
    

    span {
        color: $dark-blue;
        font-size: large;
        font-weight: bold;
    }
}

.field {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    background: $ice-blue;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(25, 118, 210, 0.04);

    align-items: center;

    margin-bottom: 1rem;

    input,
    select {
        background-color: #fff;
        border: 1px solid $platinium;
    }
}

.field > label,
.label {
    color: $dark-blue;
    font-weight: bold;
    margin-bottom: 0.2rem; 
}
</style>